import { type Candidate } from "./types/candidate";

/** The free cut from everyone a Search found to the Longlist (#135): how well
 * the headline matches a search title, plus distance. A candidate it sorted
 * out keeps that score — the record of why they aren't on the Longlist. */
export interface Vorauswahl {
  score: number;
  titleFit: number;
  location: number;
}

type ScoredRow = Pick<Candidate, "status" | "score" | "subScores" | "subReasoning">;

/** The AI explains its scores; the Vorauswahl and the algorithmic scorer don't. */
function aiScored(c: ScoredRow): boolean {
  return Object.keys(c.subReasoning).length > 0;
}

/** The Vorauswahl a candidate carries, wherever it is now (#135, #186): its
 * score has a `title` sub-score and no AI reasoning. A candidate moved to the
 * Longlist by hand keeps it until the AI scores them. Null otherwise. */
export function vorauswahlOf(c: ScoredRow): Vorauswahl | null {
  const titleFit = c.subScores.title;
  if (c.score == null || titleFit == null || aiScored(c)) return null;
  return { score: c.score, titleFit, location: c.subScores.location ?? 0 };
}

/** The score of a sorted-out row from before the Vorauswahl (or moved back for
 * an excluded employer): an algorithmic pre-score, not the AI's Match-Score, so
 * it is shown as such (#186). Null for every other row. */
export function olderPreScore(c: ScoredRow): number | null {
  if (c.status !== "pool" || c.score == null || c.subScores.title != null || aiScored(c))
    return null;
  return c.score;
}

export function olderPreScoreLine(score: number): string {
  return `Früherer Score ${score} · ohne Vorauswahl`;
}

export function vorauswahlLine(v: Vorauswahl): string {
  return `Vorauswahl ${v.score} · Titel ${v.titleFit} % · Standort ${v.location}`;
}
